// extracted by mini-css-extract-plugin
export default {"coaches":"Coaches_coaches__QTSe3","cards-grid":"Coaches_cards-grid__JgBLx","card-holder":"Coaches_card-holder__oWN5P"};